export default __webpack_public_path__ + "static/media/undraw_fitness_stats_sht6.91a26f69.svg";